enum VaatimusType {
    Hanke = "hanke",
    Vastuuyksikko = "vastuuyksikko",
    Kategorisoidut = "kategorisoidut",
}

export default VaatimusType